import { objectParticleOf } from '@safetyhub/shared';

/**
 * 양식 삭제 확인 모달의 본문 — L24(US-0723) 「어느 의무가 주인을 잃는지 경고받는다」.
 *
 * ⛔ **비차단이다** — 의무 목록이 있어도 「삭제」 버튼은 그대로 눌린다(스토리 기대가 「경고받는다」이고
 * 차단이 아니다). 삭제하면 서버가 그 연결을 해제한다(행은 이력으로 남는다 —
 * `ReportComposerService.deleteTemplate` docblock).
 *
 * `obligations === null`은 「조회 실패」다 — 「연결된 의무 없음」과 같은 모양으로 그리면 경고를 놓친 채
 * 지우게 되므로 문구를 갈라 둔다.
 */
export interface TemplateDeleteObligation {
  obligationId: string;
  title: string;
  isActive: boolean;
}

export default function TemplateDeleteConfirmBody({
  templateKey,
  obligations,
}: {
  templateKey: string;
  obligations: TemplateDeleteObligation[] | null;
}) {
  return (
    <div className="space-y-2 text-sm leading-relaxed text-gray-600">
      <p>
        템플릿 &quot;{templateKey}&quot;{objectParticleOf(templateKey)} 삭제하시겠습니까? 되돌릴 수 없습니다.
      </p>
      {obligations === null ? (
        <p data-testid="template-delete-obligations-unknown" className="text-amber-700">
          이 양식을 쓰는 법정 의무를 확인하지 못했습니다. 법정 의무 카탈로그에서 연결을 확인한 뒤 지우는 것을
          권합니다.
        </p>
      ) : obligations.length > 0 ? (
        <div
          data-testid="template-delete-obligations"
          className="rounded-card border border-amber-200 bg-amber-50 p-3 text-amber-800"
        >
          <p className="font-semibold">
            이 양식을 쓰는 법정 의무 {obligations.length}개가 양식을 잃습니다.
          </p>
          <ul className="mt-1 list-disc pl-5">
            {obligations.map((o) => (
              <li key={o.obligationId}>
                {o.title}
                {o.isActive ? '' : ' (비활성)'}
              </li>
            ))}
          </ul>
          <p className="mt-1">
            삭제하면 그 연결은 해제되고, 해당 의무는 다른 양식을 연결할 때까지 「양식 준비 중」으로 보입니다.
          </p>
        </div>
      ) : null}
    </div>
  );
}
